export const formatMoney = (amountCents: number | null): string | null => {
	// TODO: why do we show empty string instead of zero here?
	// return amountCents ? `$${(amountCents / 100).toFixed(2)}` : "";
	return `$${((amountCents || 0) / 100).toFixed(2)}`;
};
